import Vue from 'vue'
import store from "../store"
import {is_Empty} from "./utils";

let myMixin = {
        data() {
            return {
                defaultImg: '/assets/imgs/default_img.png',
                toast: null,
                success: null,

            }
        },

        methods: {
            deepClone(obj, hash = new WeakMap()) {
                if (hash.has(obj)) {
                    return obj;
                }
                let res = null;
                const reference = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error];

                if (!this.is_Empty(obj.constructor) && reference.includes(obj.constructor)) {
                    res = new obj.constructor(obj);
                } else if (Array.isArray(obj)) {
                    res = [];
                    obj.forEach((e, i) => {
                        res[i] = this.deepClone(e);
                    });
                } else if (typeof obj === "Object" && obj !== null) {
                    res = {};
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            res[key] = this.deepClone(obj[key]);
                        }
                    }
                } else {
                    res = obj;
                }
                hash.set(obj, res);
                return res;
            },
            formatDate(timestamp, fmt) {
                let time = timestamp;
                if (!time) {
                    return "- -"
                }
                if (typeof time === 'string' && time.indexOf("T") === -1) {
                    time = Date.parse(time.replace(/-/g, "/"));
                }

                if (typeof time == 'string') {
                    time = new Date(Date.parse(time.replace(/-/g, "/")));　　　　　　　 // 将时间中的"-"替换为"/"，之所以这样是因为Date()构造函数只有2012/3/10这种形式实现浏览器全兼容。
                }
                let date = new Date(time);
                let o = {
                    "M+": date.getMonth() + 1,//月份
                    "d+": date.getDate(),//日
                    "h+": date.getHours(),//小时
                    "m+": date.getMinutes(),//分
                    "s+": date.getSeconds(),//秒
                    "q+": Math.floor((date.getMonth() + 3) / 3),//季度
                    "S": date.getMilliseconds()//毫秒
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                }
                for (let k in o) {
                    if (new RegExp("(" + k + ")").test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                    }
                }
                return fmt;
            },
            //字符串转为数组
            strToArr(str, key) {
                let split_key = ',';
                if (key) {
                    split_key = key
                }
                try {
                    if (this.is_Empty(str)) return [];
                    return str.split(split_key)
                } catch (err) {
                    return [];
                }
            },
            //数组转为字符串
            arrToStr(arr, key) {
                let join_key = ',';
                if (key) join_key = key;
                try {
                    if (this.is_Empty(arr)) return "";
                    return arr.join(join_key)
                } catch (err) {
                    return "";
                }
            },
            async memberInfoInit(data) {
                data.member_type = [];
                data.role_ids = [];
                data.company_id = "";
                data.company_num = 0;
                data.auth_ids = [];

                if (!this.is_Empty(data.memberRoleBeans)) {
                    data.memberRoleBeans.forEach(el => {
                        data.member_type.push(el.auth_type);
                        data.role_ids.push(el.role_id);

                        let auth_id = "";
                        if (!this.is_Empty(el.roleBean)) {
                            auth_id = el.roleBean.auth_ids;
                        }
                        if (el.auth_type === "2" && this.is_Empty(data.company_id)) {
                            data.company_id = el.relation_id;
                        }
                        if (el.auth_type === "2") {
                            data.company_num++;
                        }
                        data.auth_ids.push(auth_id);
                    });
                }

                data.auth_ids = this.unique(data.auth_ids);
                data.member_type = this.unique(data.member_type);
                data.role_ids = this.unique(data.role_ids);

                if (!this.is_Empty(this.$store.state.current_company_id)) {
                    // 筛选出来当前登录信息是否有store中存储的公司ID，如果没有则清除掉公司ID。
                    let list = data.memberRoleBeans.filter(el => el.relation_id === this.$store.state.current_company_id && el.auth_type === "2");
                    if (list.length === 0) {
                        this.$store.commit('setCurrentCompanyId', '');
                    } else {
                        data.company_id = this.$store.state.current_company_id;
                    }
                }

                if (!this.is_Empty(this.$store.state.switchCompany)) {
                    data.company_id = this.$store.state.switchCompany.company_id;
                    this.$store.commit('setSwitchCompany', null)
                }
                this.$store.commit('setMemberInfo', data);
                if (!this.is_Empty(data.company_id)) {
                    let res = await this.post("auth/companyLogin", {});
                    data.member_token = res.data;
                }


                this.$store.commit('setMemberInfo', data);
                if (!this.is_Empty(data.member_id) && Number(data.member_id) !== 0) {
                    let res = await this.post("app/permission/getMemberPermissionList", {});
                    let arr = [];
                    res.data.forEach(el => {
                        arr.push(el.permission_id)
                    })
                    this.$store.commit('setUserPermission', arr)
                }
                // sessionStorage.setItem("memberInfo", JSON.stringify(data));
            },
            unique(arr) {
                if (!Array.isArray(arr)) {
                    console.log('type error!')
                    return
                }
                let arrry = [];
                let obj = {};
                for (let i = 0; i < arr.length; i++) {
                    if (!this.is_Empty(arr[i])) {
                        if (!obj[arr[i]]) {
                            arrry.push(arr[i])
                            obj[arr[i]] = 1
                        } else {
                            obj[arr[i]]++
                        }
                    }
                }
                return arrry;
            },
            timeago(dateTimeStamp) {
                dateTimeStamp = new Date(Date.parse(dateTimeStamp.replace(/-/g, "/")));　　　　　　　 // 将时间中的"-"替换为"/"，之所以这样是因为Date()构造函数只有2012/3/10这种形式实现浏览器全兼容。
                let date = dateTimeStamp.getTime();

                let day = 24 * 1000 * 60 * 60;
                let now = new Date(this.conversion(new Date()) + " 00:00:00").getTime(); //获取当前时间毫秒
                let diffValue = date - now; //时间差
                let dayC = Math.ceil(this.div(diffValue, day));
                dayC = Math.ceil(this.mul(dayC, 0.3));
                dayC = this.mul(dayC, day);
                date = this.add(date, dayC);
                return this.conversion(date, "yy-mm-dd")
            },
            toDecimal2(x, length) {
                length = length || 2;
                let sum = "1";
                while (sum.length <= length) {
                    sum += "0";
                }
                sum = Number(sum);
                let f = parseFloat(x);
                if (isNaN(f)) {
                    return false;
                }
                f = Math.round(x * sum) / sum;
                let s = f.toString();
                let rs = s.indexOf('.');
                if (rs < 0) {
                    rs = s.length;
                    s += '.';
                }
                while (s.length <= rs + length) {
                    s += '0';
                }
                return s;
            },
            digitUppercase(n) {
                let fraction = ['角', '分'];
                let digit = [
                    '零', '壹', '贰', '叁', '肆',
                    '伍', '陆', '柒', '捌', '玖'
                ];
                let unit = [
                    ['元', '万', '亿'],
                    ['', '拾', '佰', '仟']
                ];
                let head = n < 0 ? '欠' : '';
                n = Math.abs(n);
                let s = '';
                for (let i = 0; i < fraction.length; i++) {
                    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
                }
                s = s || '整';
                n = Math.floor(n);
                for (let i = 0; i < unit[0].length && n > 0; i++) {
                    let p = '';
                    for (let j = 0; j < unit[1].length && n > 0; j++) {
                        p = digit[n % 10] + unit[1][j] + p;
                        n = Math.floor(n / 10);
                    }
                    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
                }
                return head + s.replace(/(零.)*零元/, '元')
                    .replace(/(零.)+/g, '零')
                    .replace(/^整$/, '零元整');
            },
            back(key, value) {
                //带参数返回上一页

                if (key && value) {
                    let pages = this.$pageStack.getStack();
                    let prePage = pages[pages.length - 2];
                    prePage.vnode.componentInstance[key] = value;
                }
                this.$router.go(-1);
            },
            go(router) {
                this.$router.push(router)
            },
            redirect(router) {
                this.$router.replace(router);
            },
            set(key, value) {
                sessionStorage.setItem(key, JSON.stringify(value));
            },
            getItem(key) {
                return JSON.parse(sessionStorage.getItem(key))
            },
            remove(key) {
                sessionStorage.removeItem(key)
            },
            // 成功的提示
            successSend(meg) {
                this.$message({
                    // duration: 0, // 持续展示 toast
                    // forbidClick: true, // 禁用背景点击
                    message: meg,
                    type: "success"
                })
            },
            FilterData(a, b) {
                for (let i = 0; i < a.length; i++) {
                    if (a[i] != b[i]) {
                        return i
                    }
                }
                return false
            },
            formatPhone(phone) {
                return phone.substr(0, 3) + '****' + phone.substr(7, 11);
            },
            formatBankCard(card) {
                let str = '';
                for (let i = 0; i < card.length - 7; i++) {
                    str += '*'
                }
                return card.substr(0, 4) + str + card.substr(-3);
            },
            // 验证手机号
            checkPhone(phone) {
                return /^1(3|4|5|6|7|8|9)\d{9}$/.test(phone);
            },
            // 验证统一社会信用代码
            checkTaxId(taxId) {
                return /[0-9A-Z]{18}/.test(taxId);
                let regArr = [/^[\da-z]{10,15}$/i, /^\d{6}[\da-z]{10,12}$/i, /^[a-z]\d{6}[\da-z]{9,11}$/i, /^[a-z]{2}\d{6}[\da-z]{8,10}$/i, /^\d{14}[\dx][\da-z]{4,5}$/i, /^\d{17}[\dx][\da-z]{1,2}$/i, /^[a-z]\d{14}[\dx][\da-z]{3,4}$/i, /^[a-z]\d{17}[\dx][\da-z]{0,1}$/i, /^[\d]{6}[\da-z]{13,14}$/i];
                taxId = taxId.replace(/\s+/g, "");
                for (let i = 0; i < regArr.length; i++) {
                    if (regArr[i].test(taxId)) {
                        return true;
                    }
                }
                //纳税人识别号格式错误
                return false;
            },
            // 验证银行卡号
            checkback(value) {
                value = value.replace(/\s+/g, "");
                let regArr = /^([1-9]{1})(\d{15}|\d{18})$/;
                return regArr.test(value);
            },
            // 时间戳转换
            conversion(timestamp, length) {
                let leng = length || 3;
                let date = new Date(timestamp);
                let Y = date.getFullYear();
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
                let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                let h = date.getHours() + ':';
                let m = date.getMinutes() + ':';
                let s = date.getSeconds();
                if (leng == 3) {
                    return Y + '-' + M + '-' + D;
                } else if (leng == "yy-mm-dd") {
                    return Y + "年" + M + '月' + D + '日';
                } else {
                    return Y + '-' + M + '-' + D + " " + h + m + s;

                }
            },
            // 加
            add(a, b) {
                let c, d, e;
                try {
                    c = a.toString().split(".")[1].length;
                } catch (f) {
                    c = 0;
                }
                try {
                    d = b.toString().split(".")[1].length;
                } catch (f) {
                    d = 0;
                }
                return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
            },
            // 减
            sub(a, b) {
                let c, d, e;
                try {
                    c = a.toString().split(".")[1].length;
                } catch (f) {
                    c = 0;
                }
                try {
                    d = b.toString().split(".")[1].length;
                } catch (f) {
                    d = 0;
                }
                return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
            },
            // 乘
            mul(a, b) {
                let c = 0;
                // if (typeof (a) == "number") {
                try {

                    var d = a.toString();
                } catch (error) {

                }
                try {
                    var e = b.toString();
                } catch (error) {

                }
                try {
                    c += d.split(".")[1].length;
                } catch (f) {
                }
                try {
                    c += e.split(".")[1].length;
                } catch (f) {
                }
                try {
                    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
                } catch (error) {
                }
            },
            // 除
            div(a, b) {
                let c, d, e = 0,
                    f = 0;
                try {
                    e = a.toString().split(".")[1].length;
                } catch (g) {
                }
                try {
                    f = b.toString().split(".")[1].length;
                } catch (g) {
                }
                return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(10, f - e));
            },
            is_Empty(targe) {
                if (targe === undefined) {
                    return true;
                }
                if (typeof targe === undefined)
                    return true;
                if (typeof targe == 'number')
                    return false;
                if (typeof targe == 'string') {
                    if (targe == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
                if (targe === null) {
                    return true;
                }
                if (typeof targe == 'object') {
                    for (let i in targe) {
                        return false;
                    }
                    return true;
                }
                return false;

            },
            isJSON(str) {
                try {
                    let s = JSON.parse(str);
                    return true;
                } catch (error) {
                    return false;
                }
            },
            order_state_decide(row) {
                // pay_state == 0 待付款 pay_state == 1 已付第一笔  pay_state == 2  已付第二笔   pay_state == 3 已付完
                // send_state == 1 未发货 send_state == 2 部分发货 send_state == 3 全部发货  send_state == 4 已收货


                if (row.company_check_state == '-1') {
                    return `<span class="black">用户取消</span>`
                }

                if (row.company_check_state == '1' && row.platform_sale_check_state == '-1') {
                    return `<span class="red">销售驳回</span>`
                }
                if (row.company_check_state == '1' && row.platform_sale_check_state == '0') {
                    return `<span class="orange">待销售审核</span>`
                }
                if (row.company_check_state == '1' &&
                    row.platform_sale_check_state == '1' &&
                    row.contract_check_state == '-1') {
                    return `<span class="red">合同审核不通过</span>`
                }
                if (row.company_check_state == '1' &&
                    row.platform_sale_check_state == '1' &&
                    row.contract_check_state == '0') {
                    return '<span class="orange">待合同审核</span>'
                }
                // if (row.company_check_state == '1' &&
                //     row.platform_sale_check_state == '1' &&
                //     row.company_check2_state == '0') {
                //     return '<span class="orange">待用户确认</span>'
                // }


                if (row.pay_state == '0') {
                    return `<span class="red">待付款生产</span>`
                }
                if (row.pay_state == '1') {
                    return `<span class="orange">待付款发货</span>`
                }
                if (row.pay_state == '2' && row.send_state == '1') {
                    return `<span class="blue">待发货</span>`
                }
                if (row.pay_state == '2') {
                    return `<span class="blue">待货到付款</span>`
                }
                if (row.pay_state == '3' && row.send_state == '1') {
                    return `<span class="blue">待发货</span>`
                }
                if (row.pay_state == '3' && row.send_state == '2' || row.pay_state == '3' && row.send_state == '3') {
                    return `<span class="blue">待收货</span>`
                }
                if (row.pay_state == '3' && row.send_state == '4') {
                    return `<span class="blue">待评价</span>`
                }

                return `<span class="green">已完成</span>`
            },

            service_state_decide(row) {
                // pay_state == 0 待付款 pay_state == 1 已付第一笔  pay_state == 2  已付第二笔   pay_state == 3 已付完

                // private String company_check_state;//客户下单状态
                // private String platform_sale_check_state;//平台销售审核状态 -1:驳回 0:待审核 1:通过
                // private String platform_sale_check_time;//审核时间
                // private String company_check2_state;//客户二次确认
                // private String company_check2_time;//二次确认时间
                // private String technician_check_state;//技术接单
                // private String technician_assign_state;//指派技术状态
                // private String technician_assign_time;//指派技术时间
                // private String pay_state;//支付状态 0:未支付 1:已支付


                if (row.company_check_state == '-1') {
                    return "用户取消"
                }
                if (row.company_check_state == '1' && row.platform_sale_check_state == '-1') {
                    return "销售驳回"
                }
                if (row.company_check_state == '1' && row.platform_sale_check_state == '0') {
                    return "待销售审核"
                }
                if (row.company_check_state == '1' &&
                    row.platform_sale_check_state == '1' &&
                    row.contract_check_state == '-1') {
                    return "合同审核不通过"
                }
                if (row.company_check_state == '1' &&
                    row.platform_sale_check_state == '1' &&
                    row.contract_check_state == '0') {
                    return "待合同审核"
                }
                if (row.technician_assign_state == '0') {
                    return "待指派订单"
                }
                if (row.technician_assign_state == '1') {
                    return "已指派订单"
                }
                if (row.technician_check_state == '-1') {
                    return "技术拒绝接单"
                }
                if (row.technician_check_state == '0') {
                    return "待技术接单"
                }
                if (row.technician_check_state == '1') {
                    return "技术已接单"
                }

                if (row.pay_state == '0') {
                    return "待付款"
                }
                if (row.pay_state == '1') {
                    return "已付款"
                }

            },
            role_name(role_id, auth_type) {
                if (auth_type == '2') {
                    switch (role_id) {
                        case '1':
                            return "技术员"
                            break;
                        case '10':
                            return "管理员"
                            break;
                        case '3':
                            return "财务"
                            break;
                        case '2':
                            return "采购"
                            break;
                        default:
                            return "错误"
                            break;
                    }
                } else if (auth_type == '4') {
                    switch (role_id) {
                        case '15':
                            return "技术员"
                            break;
                        case '14':
                            return "管理员"
                            break;
                        case '9':
                            return "财务"
                            break;
                        case '8':
                            return "销售"
                        case '12':
                            return "客服"
                            break;
                        default:
                            return "错误"
                            break;
                    }
                } else if (auth_type == '5') {
                    switch (role_id) {
                        case '13':
                            return "营销合伙人"
                            break;
                        case '7':
                            return "技术服务合伙人"
                            break;

                    }
                }

            },
            specNameInit(goods, key) {
                try {
                    if (this.is_Empty(goods)) return "";
                    let obj_key = 'orderGoodsSpecificationInputBeans';
                    if (!this.is_Empty(key)) {
                        obj_key = key;
                    }
                    let spc_name = [];
                    let excludeFields = ['定制', '小于', '大于']
                    if (!this.is_Empty(goods.specification_name) && excludeFields.every(el => goods.specification_name.indexOf(el) === -1)) {
                        spc_name.push(goods.specification_name)
                    }
                    let obj = {};
                    goods[obj_key].forEach(el => {
                        obj[el.input_name] = Number(el.input_value);
                    })

                    //如果spc_name数组不为空说明该商品为标准商品则直接拼接就行，不需要加*号。
                    if (!spc_name.length) {
                        if (obj.hasOwnProperty('goods_length')) {
                            spc_name.push(`${obj.goods_length}m`)
                        }
                        if (obj.hasOwnProperty('goods_width')) {
                            spc_name.push(`${obj.goods_width}m`)
                        }
                        if (obj.hasOwnProperty('weight')) {
                            spc_name.push(`${obj.weight}${goods.price_unit}`)
                        }
                        return spc_name.join("*");
                    } else {
                        if (obj.hasOwnProperty('goods_length')) {
                            spc_name.push(`长度:${obj.goods_length}m`)
                        }
                        if (obj.hasOwnProperty('goods_width')) {
                            spc_name.push(`宽度:${obj.goods_width}m`)
                        }
                        if (obj.hasOwnProperty('weight')) {
                            spc_name.push(`重量:${obj.weight}${goods.price_unit}`)
                        }
                        return spc_name.join(" ");
                    }
                } catch (e) {
                    return ""
                }
            },
            //权限
            hasPermission(auth_id) {
                let permission_ids = store.state.permission_ids
                if (is_Empty(permission_ids)) permission_ids = [];
                if (!Array.isArray(permission_ids)) {
                    permission_ids = permission_ids.split(",").map(Number);
                }
                if (Array.isArray(auth_id)) {
                    return auth_id.some(el => {
                        return permission_ids.indexOf(Number(el)) !== -1;
                    })
                }
                auth_id = Number(auth_id);
                return permission_ids.indexOf(auth_id) !== -1;

            },
            //权限
            hasRole(role_id) {
                let role_ids = store.state.memberInfo.role_ids;
                if (is_Empty(role_ids)) role_ids = [];
                if (!Array.isArray(role_ids)) {
                    role_ids = role_ids.split(",");
                }
                if (Array.isArray(role_id)) {
                    return role_id.some(el => {
                        return role_ids.indexOf(Number(el)) !== -1;
                    })
                }
                return role_ids.indexOf(role_id) !== -1;
            },
            //权限
            hasMemberType(role_id) {
                if (this.is_Empty(store.state.memberInfo)) return false;
                let role_ids = store.state.memberInfo.member_type || []
                if (!Array.isArray(role_ids)) {
                    role_ids = role_ids.split(",");
                }
                if (Array.isArray(role_id)) {
                    return role_id.some(el => {
                        return role_ids.indexOf(Number(el)) !== -1;
                    })
                }
                return role_ids.indexOf(role_id) !== -1;
            }

        },
    }
;

Vue.mixin(myMixin);


// WEBPACK FOOTER //
// ./src/utils/mixin.js